module.exports = "<p-fileUpload name=\"files\"\n              [url]=\"filesLocationUrl$ | async\"\n              (onSelect)=\"onSelect($event)\"\n              (onBeforeSend)=\"onBeforeSend($event)\"\n              (onUpload)=\"onUpload($event)\"\n              (onClear)=\"onClear($event)\"\n              (onError)=\"onError($event)\"\n              auto=\"auto\"\n              multiple=\"multiple\"\n              maxFileSize=\"10020971520\">\n</p-fileUpload>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/files/file-uploader/file-uploader.component.html
// module id = 1460
// module chunks = 0